/**
 * Checkout right-column order summary (Figma CHECKOUT-LANDING-04/05 — nodes 5759:21470, 5759:25430).
 */
const CheckoutOrderSummary = {
  parts: [
    'root',
    'headerRow',
    'heading',
    'itemCount',
    'reservationNote',
    'itemsList',
    'itemDivider',
    'mobileAccordionButton',
    'mobileAccordionIcon',
    'mobileReservationNote',
    'mobileAccordionPanel',
    'promoForm',
    'promoFormActive',
    'promoFormError',
    'promoFieldText',
    'promoFieldLabel',
    'promoFieldLabelError',
    'promoInput',
    'promoApply',
    'promoApplyError',
    'promoErrorMessage',
    'promoErrorIcon',
    'promoErrorText',
    'promoAppliedList',
    'promoAppliedItem',
    'promoAppliedItemInactive',
    'promoAppliedStatus',
    'promoAppliedTagIcon',
    'promoAppliedCode',
    'promoRemove',
    'pricingSummary',
    'pricingBreakdown',
    'priceRow',
    'priceRowLabel',
    'priceRowValue',
    'priceRowDivider',
    'totalRow',
    'totalRowLabel',
    'totalRowValue',
    'totalBlockWithDeposit',
    'depositPaidTodayRow',
    'depositPaidTodayLabel',
    'depositPaidTodayValue',
    'shippingLoading',
  ],
  baseStyle: {
    root: {
      display: 'flex',
      flexDirection: 'column',
      gap: {base: 6, lg: 8},
      width: '100%',
      position: 'relative',
      zIndex: 1,
    },
    headerRow: {
      alignItems: 'center',
      gap: {base: '12px', lg: '6px'},
      justifyContent: 'space-between',
      width: '100%',
    },
    heading: {
      color: 'grayAlpha.90',
      flex: 1,
      fontFamily: 'body',
      fontFeatureSettings: "'lnum' 1, 'pnum' 1",
      fontSize: {base: '14px', lg: '24px'},
      fontWeight: {base: '600', lg: '500'},
      lineHeight: 1.4,
      margin: 0,
      minW: 0,
      textAlign: 'left',
      sx: {
        '&&&': {
          fontSize: {base: '14px', lg: '24px'},
          fontWeight: {base: 600, lg: 500},
          lineHeight: 1.4,
        },
      },
    },
    itemCount: {
      color: {base: 'grayAlpha.90', lg: 'greyscale.100'},
      flex: {base: 1, lg: 'unset'},
      flexShrink: 0,
      fontFamily: 'body',
      fontFeatureSettings: "'lnum' 1, 'pnum' 1",
      fontSize: {base: '14px', lg: '16px'},
      fontWeight: '400',
      lineHeight: 1.4,
      minW: 0,
      textAlign: 'right',
      whiteSpace: 'nowrap',
    },
    reservationNote: {
      color: 'greyscale.100',
      fontSize: {base: '14px', lg: '16px'},
      fontWeight: '400',
      lineHeight: 1.4,
      width: '100%',
    },
    itemsList: {
      display: 'flex',
      flexDirection: 'column',
      gap: {base: '24px', lg: 4},
      width: '100%',
      sx: {
        '.cart-item__name': {
          color: 'grayAlpha.90',
          fontFeatureSettings: "'lnum' 1, 'pnum' 1",
          fontSize: {base: '14px', lg: '16px'},
          fontWeight: '600',
          lineHeight: 1.4,
        },
        '.cart-item__short-desc, .cart-item__config-text': {
          color: 'greyscale90Alpha.70',
          fontSize: {base: '13px', lg: '12px'},
          fontWeight: '400',
          lineHeight: 1.2,
        },
        '.cart-item__promo': {
          color: 'secondary.newSaleRed',
          fontSize: {base: '13px', lg: '12px'},
          fontWeight: '400',
          lineHeight: 1.2,
        },
        '.cart-item__actions': {
          alignItems: {base: 'flex-start', lg: 'center'},
          flexDirection: {base: 'column', lg: 'row'},
          flexWrap: 'nowrap',
          gap: '24px',
          marginTop: 0,
          paddingBottom: {base: 0, lg: '12px'},
          paddingTop: {base: '12px', lg: '24px'},
          width: {base: '100%', lg: 'auto'},
        },
        '.cart-item__cta-group': {
          gap: '24px',
          '& .cart-item__edit-btn[disabled]': {
            cursor: 'not-allowed',
            pointerEvents: 'unset',
          },
        },
        '.cart-item__edit-btn': {
          color: 'primary.darkLinen',
          fontSize: {base: '14px', lg: '16px'},
          fontWeight: '400',
          lineHeight: 1.4,

          '&:after': {
            bottom: '-2px',
          },
          '&[disabled], &[aria-disabled="true"]': {
            color: 'greyscale.40',
            cursor: 'not-allowed',
            pointerEvents: 'none',
          },
        },
        '.cart-item__remove-btn': {
          color: 'primary.darkLinen',
          fontSize: {base: '14px', lg: '16px'},
          fontWeight: '400',
          lineHeight: 1.4,

          '&:after': {
            bottom: '-2px',
          },
        },
        '.cart-item__qty-wrapper': {
          maxWidth: '112px',
          width: '112px',
        },
        '.cart-item__price-col': {
          gap: '6px',
        },
        '.cart-item__price-current': {
          color: 'grayAlpha.90',
          fontFeatureSettings: "'lnum' 1, 'pnum' 1",
          fontSize: {base: '14px', lg: '16px'},
          fontWeight: '600',
          lineHeight: 1.4,
          textAlign: 'right',
        },
        '.cart-item__price-original': {
          color: 'greyscale.70',
          fontSize: {base: '13px', lg: '12px'},
          fontWeight: '400',
          lineHeight: 1.2,
          textAlign: 'right',
          textDecoration: 'line-through',
        },
        '.cart-item__cta-sep': {
          height: {base: '20px', lg: '22px'},
        },
        '.cart-item__out-of-stock-alert': {
          marginTop: {base: '16px', lg: 'unset'},
          '.cart-flyout &': {
            marginTop: {base: '0', lg: 'unset'},
            marginBottom: {base: '0', lg: '0'},
          },
          '.checkout-order-summary &': {
            marginTop: {base: '24px', lg: 'unset'},
            marginBottom: {base: '0', lg: '8px'},
          },
        },
      },
    },
    itemDivider: {
      bg: 'greyscale90Alpha.10',
      flexShrink: 0,
      h: '1px',
      w: 'full',
      borderColor: 'transparent',
    },
    mobileAccordionButton: {
      _hover: {bg: 'transparent'},
      alignItems: 'center',
      display: 'flex',
      gap: '12px',
      px: 0,
      py: 0,
      width: '100%',
    },
    mobileAccordionIcon: {
      color: 'greyscale.100',
      flexShrink: 0,
      height: '12px',
      ml: 0,
      width: '13px',
    },
    mobileReservationNote: {
      mt: 6,
      width: '100%',
    },
    mobileAccordionPanel: {
      pb: 0,
      pt: 6,
      px: 0,
    },
    promoForm: {
      alignItems: 'center',
      bg: 'white',
      border: '1px solid',
      borderColor: 'greyscale90Alpha.10',
      borderRadius: '4px',
      display: 'flex',
      gap: 2.5,
      h: '54px',
      px: '18px',
      py: 0,
      width: '100%',
    },
    promoFormActive: {
      borderColor: 'primary.darkLinen',
      py: '4px',
    },
    // Error state — applied when the promo code form has a validation error.
    // Overrides border + background to match the design's red error treatment.
    promoFormError: {
      bg: 'error.background',
      borderColor: 'error.standard',
    },
    promoFieldText: {
      display: 'flex',
      flex: 1,
      flexDirection: 'column',
      gap: '4px',
      justifyContent: 'center',
      minW: 0,
    },
    promoFieldLabel: {
      color: 'primary.darkLinen',
      fontSize: '13px',
      fontWeight: '400',
      lineHeight: 1.2,
    },
    promoFieldLabelError: {
      color: 'error.standard',
    },
    promoInput: {
      _focus: {boxShadow: 'none'},
      _placeholder: {color: 'greyscale90Alpha.80'},
      border: 'none',
      color: 'grayAlpha.90',
      flex: 1,
      fontSize: {base: '14px', lg: '16px'},
      fontWeight: '400',
      h: 'auto',
      lineHeight: 1.4,
      minH: '20px',
      minW: 0,
      px: 0,
      py: 0,
    },
    promoApply: {
      _disabled: {
        color: 'greyscale.30',
        cursor: 'not-allowed',
        opacity: 1,
      },
      _hover: {textDecoration: 'none'},
      color: 'primary.darkLinen',
      flexShrink: 0,
      fontSize: {base: '14px', lg: '16px'},
      fontWeight: '600',
      h: 'auto',
      lineHeight: 1.4,
      minW: 'auto',
      px: 0,
      textDecoration: 'none',
      variant: 'link',
    },
    promoApplyError: {
      color: 'error.standard',
    },
    promoErrorMessage: {
      alignItems: 'center',
      color: 'error.standard',
      display: 'flex',
      fontSize: {base: '13px', lg: '14px'},
      gap: '8px',
      lineHeight: 1.4,
      mt: '8px',
      pl: 4,
      pr: {base: 4.5, lg: 4},
    },
    promoErrorIcon: {
      boxSize: '16px',
      color: 'error.standard',
      flexShrink: 0,
    },
    promoErrorText: {
      color: 'error.standard',
      fontSize: {base: '13px', lg: '14px'},
      lineHeight: 1.4,
    },
    promoAppliedList: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      gap: '8px',
      mt: '8px',
      width: '100%',
    },
    promoAppliedItem: {
      alignItems: 'center',
      bg: 'brandColors.secondaryBG',
      borderRadius: '33px',
      height: '33px',
      display: 'inline-flex',
      flexShrink: 0,
      gap: '8px',
      maxW: '100%',
      px: '16px',
      py: '8px',
    },
    promoAppliedItemInactive: {
      bg: 'transparent',
      border: '1px dashed',
      borderColor: 'error.standard',
    },
    promoAppliedStatus: {
      color: 'error.standard',
      fontSize: {base: '12px', lg: '13px'},
      fontWeight: '600',
      lineHeight: 1.2,
      textTransform: 'uppercase',
      whiteSpace: 'nowrap',
    },
    promoAppliedTagIcon: {
      color: 'grayAlpha.90',
      flexShrink: 0,
      h: {base: '14px', lg: '16px'},
      w: {base: '14px', lg: '16px'},
    },
    promoAppliedCode: {
      color: {base: 'brandColors.primaryText', lg: 'greyscale.100'},
      fontFeatureSettings: "'lnum' 1, 'pnum' 1",
      fontSize: {base: '14px', lg: '16px'},
      fontWeight: '600',
      lineHeight: 1.2,
      whiteSpace: 'nowrap',
    },
    promoRemove: {
      _active: {bg: 'transparent'},
      _hover: {bg: 'transparent', color: 'primary.darkLinen'},
      alignItems: 'center',
      color: 'grayAlpha.90',
      display: 'inline-flex',
      flexShrink: 0,
      h: {base: '14px', lg: '16px'},
      justifyContent: 'center',
      minW: {base: '14px', lg: '16px'},
      p: 0,
      variant: 'unstyled',
      sx: {
        '& svg': {
          h: {base: '14px', lg: '16px'},
          w: {base: '14px', lg: '16px'},
        },
      },
    },
    pricingSummary: {
      display: 'flex',
      flexDirection: 'column',
      gap: '24px',
      width: '100%',
    },
    pricingBreakdown: {
      display: 'flex',
      flexDirection: 'column',
      gap: '14px',
      width: '100%',
    },
    priceRow: {
      alignItems: 'center',
      justifyContent: 'space-between',
      width: '100%',
    },
    priceRowLabel: {
      color: 'greyscale90Alpha.70',
      flex: '1 0 0',
      fontFamily: 'body',
      fontSize: {base: '14px', lg: '16px'},
      fontWeight: '400',
      lineHeight: 1.4,
      minW: 0,
      sx: {
        '&&&': {
          color: 'greyscale90Alpha.70',
          marginBottom: '0',
        },
      },
    },
    priceRowValue: {
      color: 'greyscale90Alpha.70',
      flex: '1 0 0',
      fontFamily: 'body',
      fontSize: {base: '14px', lg: '16px'},
      fontWeight: '400',
      lineHeight: 1.4,
      minW: 0,
      textAlign: 'right',
      sx: {
        '&&&': {
          color: 'greyscale90Alpha.70',
          marginBottom: '0',
        },
      },
    },
    priceRowDivider: {
      bg: 'greyscale90Alpha.10',
      flexShrink: 0,
      h: '1px',
      minH: '1px',
      w: 'full',
    },
    totalRow: {
      alignItems: 'flex-start',
      justifyContent: 'space-between',
      width: '100%',
    },
    totalRowLabel: {
      color: 'greyscale.100',
      flex: '1 0 0',
      fontFamily: 'body',
      fontFeatureSettings: "'lnum' 1, 'pnum' 1",
      fontSize: {base: '20px', lg: '24px'},
      fontWeight: {base: '500', lg: '500'},
      lineHeight: {base: 1.5, lg: 1.4},
      minW: 0,
      sx: {
        '&&&': {
          color: 'greyscale.100',
          marginBottom: '0',
        },
      },
    },
    totalRowValue: {
      color: 'greyscale.100',
      flex: '1 0 0',
      fontFamily: 'body',
      fontFeatureSettings: "'lnum' 1, 'pnum' 1",
      fontSize: {base: '20px', lg: '24px'},
      fontWeight: {base: '500', lg: '500'},
      lineHeight: {base: 1.5, lg: 1.4},
      minW: 0,
      textAlign: 'right',
      sx: {
        '&&&': {
          color: 'greyscale.100',
          marginBottom: '0',
        },
      },
    },
    totalBlockWithDeposit: {
      display: 'flex',
      flexDirection: 'column',
      gap: '8px',
      width: '100%',
    },
    depositPaidTodayRow: {
      alignItems: 'flex-start',
      gap: {base: '12px', lg: '16px'},
      justifyContent: 'space-between',
      width: '100%',
    },
    depositPaidTodayLabel: {
      color: 'greyscale.100',
      flex: '1 1 auto',
      fontFamily: 'body',
      fontFeatureSettings: "'lnum' 1, 'pnum' 1",
      fontSize: {base: '14px', lg: '16px'},
      fontWeight: '500',
      lineHeight: 1.4,
      minW: 0,
      sx: {
        '&&&': {
          color: 'greyscale.100',
          marginBottom: '0',
        },
      },
    },
    depositPaidTodayValue: {
      color: 'greyscale.100',
      flex: '0 0 auto',
      fontFamily: 'body',
      fontFeatureSettings: "'lnum' 1, 'pnum' 1",
      fontSize: {base: '14px', lg: '16px'},
      fontWeight: '500',
      lineHeight: 1.4,
      textAlign: 'right',
      whiteSpace: 'nowrap',
      sx: {
        '&&&': {
          color: 'greyscale.100',
          marginBottom: '0',
        },
      },
    },
    shippingLoading: {
      alignItems: 'center',
      gap: 2,
      justifyContent: 'space-between',
      width: '100%',
    },
  },
};

export default CheckoutOrderSummary;
